const TABLE_HEADER_HEIGHT = 31;
const TABLE_ROW_HEIGHT = 53;
const MIN_TABLE_ROWS = 4;
export const MIN_TABLE_HEIGHT = TABLE_HEADER_HEIGHT + TABLE_ROW_HEIGHT * MIN_TABLE_ROWS;
export const MAX_DISPLAYED_BRANDS = 3;
export const MAX_HIDDEN_BRANDS = 10;
export const MAX_TABLE_ITEMS = 10;
export const EXCEL_API_ENDPOINT =
    "/api/aiTracker/reports/brandVisibilityReport/TopicsVisibilityTable/Excel";
